import axios from "axios";


// const baseURL = !process.env.NODE_ENV || process.env.NODE_ENV === 'development' ? 'api.staging.bik.ai/dm' : 'bikapi.bikayi.app/dm'
const baseURL = 'bap-2adcfj52ea-el.a.run.app';
const campaignName = 'stw-april-campaign';

export const checkUserEligibility = async (phoneNumber: string) => {
  const res =  await axios.post(`https://${baseURL}/shoppersStopApiFunctions-checkUserEligibility`, {
       phoneNumber: phoneNumber
   })
   return res.data
}

export const startGame = async (phoneNumber: string) => {
    const res = await axios.post(`https://${baseURL}/shoppersStopApiFunctions-startGame`, {
        phoneNumber: phoneNumber
    })
    return res
}

export const endGame = async (phoneNumber: string) => {
    const res = await axios.post(`https://${baseURL}/shoppersStopApiFunctions-endGame`, {
        phoneNumber: phoneNumber,
        gameResult: 'won'
    })
    return res
 }

 export const claimReward = async (phoneNumber: string, couponId?: string) => {
    const res = await axios.post(`https://marketing.bikayi.app/v1/ss/claim`, {
        phoneNumber: phoneNumber,
        reservedCouponId: couponId,
    })
    return res.data
 }
 export const pageVisited = async (pathname: string) => {
    const res = await axios.get(`https://${baseURL}/shoppersStopApiFunctions-pageVisited`,{ params: {pathname}});
    return res.data
 }


 export const claimRewardv1 = async (phoneNumber: string, couponId: string, captchaToken: string) => {
    const res = await axios.post(`https://${baseURL}/shoppersStopApiFunctions-claimReward`, {
        phoneNumber: phoneNumber,
        reservedCouponId: couponId,
        captchaToken: captchaToken,
    })
    return res.data
 }

 //https://marketing.bikayi.app/v1/ss/visit
 export const pageVisitedSTW = async (pathname: string) => {
     const res = await axios.post(`https://marketing.bikayi.app/v1/ss/visit`, {
         pathName: pathname,
         campaign: campaignName
     })
     return res.data
 }

 //https://marketing.bikayi.app/v1/ss/claim
 export const claimRewardSTW = async (phoneNumber: string, couponId: string, captchaToken: string, pathname: string) => {
    const res = await axios.post(`https://marketing.bikayi.app/v1/ss/claim`, {
        phoneNumber: phoneNumber,
        reservedCouponId: couponId,
        captchaToken: captchaToken,
        pathName: pathname,
        campaign: campaignName
    })
    return res.data
 }

 //https://marketing.bikayi.app/v1/ss/startGame
 export const startGameSTW = async (pathname: string) => {
    const res = await axios.post(`https://marketing.bikayi.app/v1/ss/startGame`, {
        pathName: pathname,
        campaign: campaignName
    })
    return res
}

//https://marketing.bikayi.app/v1/ss/endGame
export const endGameSTW = async (pathname: string) => {
    const res = await axios.post(`https://marketing.bikayi.app/v1/ss/endGame`, {
        gameResult: 'won',
        pathName: pathname,
        campaign: campaignName
    })
    return res
 }

